(() => {
  if (window.HSPremiumPDP) {
    window.HSPremiumPDP.refresh();
    return;
  }
  const controllers = new WeakMap();

  const visible = element => {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    const rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height || rect.bottom <= 0 || rect.top >= innerHeight) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  };

  const enhance = product => {
    if (controllers.has(product)) return;
    const bar = product.querySelector('[data-premium-sticky]');
    const purchase = product.querySelector('[data-add-button]');
    const control = bar?.querySelector('[data-premium-options]');
    if (!bar || !purchase || !control) return;

    const mobile = matchMedia('(max-width: 989px)');
    let frame;
    const headerHeight = () => document.querySelector('.site-header')?.getBoundingClientRect().height || 82;
    const blocked = () => {
      if (document.querySelector('dialog[open], .mobile-nav[open]')) return true;
      return [...document.querySelectorAll('[role="dialog"], #shopify-pc__banner, #shopify-pc__prefs, .shopify-pc__banner__dialog, .shopify-pc__prefs__dialog')].some(visible);
    };
    const sync = () => {
      frame = undefined;
      if (!product.isConnected) return;
      const rect = purchase.getBoundingClientRect();
      const viewport = window.visualViewport;
      const viewportBottom = viewport ? viewport.offsetTop + viewport.height : innerHeight;
      const purchaseVisible = rect.bottom > headerHeight() && rect.top < viewportBottom;
      const keyboardOpen = viewport && viewport.height < innerHeight * 0.72;
      const shouldShow = !purchaseVisible && !blocked() && !keyboardOpen && (mobile.matches || rect.bottom <= headerHeight());
      if (bar.hidden === shouldShow) bar.hidden = !shouldShow;
    };
    const schedule = () => {
      if (frame === undefined) frame = requestAnimationFrame(sync);
    };
    const goToOptions = () => {
      const options = product.querySelector('.variant-options');
      const fallback = product.querySelector('[data-variant-select]');
      const target = options?.getBoundingClientRect().height ? options : fallback?.getBoundingClientRect().height ? fallback : purchase;
      const focus = target.querySelector?.('input:checked') || target.querySelector?.('input, select') || target;
      const top = scrollY + target.getBoundingClientRect().top - headerHeight() - 18;
      window.scrollTo({top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      focus.focus({preventScroll: true});
    };

    control.addEventListener('click', goToOptions);
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    window.visualViewport?.addEventListener('resize', schedule, {passive: true});
    document.addEventListener('hs:variant-change', schedule);
    const intersection = new IntersectionObserver(schedule);
    intersection.observe(purchase);
    const resize = new ResizeObserver(schedule);
    resize.observe(product);
    const overlays = new MutationObserver(schedule);
    overlays.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'style', 'class']});

    controllers.set(product, () => {
      intersection.disconnect();
      resize.disconnect();
      overlays.disconnect();
      cancelAnimationFrame(frame);
      control.removeEventListener('click', goToOptions);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.visualViewport?.removeEventListener('resize', schedule);
      document.removeEventListener('hs:variant-change', schedule);
      controllers.delete(product);
    });
    schedule();
  };

  const enhanceWithin = scope => {
    scope.querySelectorAll?.('hs-product.hs-premium-pdp').forEach(enhance);
  };
  window.HSPremiumPDP = {refresh: () => enhanceWithin(document)};
  enhanceWithin(document);
  document.addEventListener('shopify:section:load', event => enhanceWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll?.('hs-product.hs-premium-pdp').forEach(product => controllers.get(product)?.());
  });
})();
